import React from "react";
import * as Constants from "../../utils/Constants";
import { Card, Image, Label, Icon, Button } from "semantic-ui-react";
import classNames from "classnames";
import { mapWorkstationToSize } from "../../utils/helpers/workstationHelper";

import "./SingleItem.css";

const SingleItem = ({ isCurrent, manualSkuCallback, missingCallback, boxItem }) => {
  const {
    verifiedQuantity,
    reservedQuantity,
    imageURL,
    skuID,
    name,
    boxID,
    isMultiPack,
    shelfNumber,
    isPackPrio,
    wasCancelled,
    isLocked,
    lockedWorkstation,
    packable,
    prefilled,
  } = boxItem;

  const outerDivClasses = classNames({
    SingleItemWrapper: true,
    current: isCurrent,
    packprio: isPackPrio,
    "not-accessible": !packable,
    locked: isLocked,
  });

  const singleItemImageContainerClasses = classNames({
    SingleItemImageContainer: true,
    "not-accessible": !packable,
  });

  return (
    <Card
      className={outerDivClasses}
      onDoubleClick={() =>
        packable &&
        prefilled === -1 &&
        manualSkuCallback && manualSkuCallback("K" + skuID, Constants.SCAN_INPUT_TYPE_SKU, boxID)
      }
      data-boxid={boxID}
    >
      <Card.Content>
        <Card.Header>
          <h3>{name}</h3>
        </Card.Header>
        {skuID}
        {isLocked && (
          <div>
            <i aria-hidden="true" className="lock large icon packprio"></i>
            <span className="locked-workstation">
              {isLocked ? "(" + mapWorkstationToSize(lockedWorkstation) + ")" : ""}
            </span>
          </div>
        )}
        <div className={singleItemImageContainerClasses}>
          <Image
            src={imageURL}
            onError={(e, t) => (e.currentTarget.src = "https://placehold.co/280x280")}
          />
        </div>
        {isMultiPack ? <div className="SingleItemMultiPackLabel">STORPACK</div> : null}
        {isPackPrio || wasCancelled ? (
          <div>
            {isPackPrio ? <Icon name="shipping" size="large" className="packprio" /> : ""}
            {wasCancelled ? <span className="aborted">AVBRUTEN</span> : ""}
          </div>
        ) : null}
        {!missingCallback || isCurrent || !packable || prefilled > 0 ? null : (
          <Button color="orange" onClick={() => missingCallback(skuID, shelfNumber, boxItem)}>
            Saknas
          </Button>
        )}
        <Label
          floating
          size="large"
          color={reservedQuantity - verifiedQuantity > 1 ? "red" : "grey"}
        >
          {reservedQuantity - verifiedQuantity}
        </Label>
      </Card.Content>
    </Card>
  );
};

export default SingleItem;
